import * as React from "react";
import EventDefinitionPriorityEnum from "logic/alerts/EventDefinitionPriorityEnum";
import StringUtils from "util/StringUtils";
const PriorityName = ({ priority }) => /* @__PURE__ */ React.createElement(React.Fragment, null, StringUtils.capitalizeFirstLetter(EventDefinitionPriorityEnum.properties[priority].name));
export default PriorityName;
